import BaseApi from "./BaseApi";
const baseUrl = 'api/AuthorizedStore/';

class AuthorizedStoreService {

    static setHeadOffice(request: any) {
        return BaseApi.post(`${baseUrl}HeadOffice`, request);
    }
    static setBranchOffice(request: any) {
        return BaseApi.post(`${baseUrl}BranchOffice`, request);
    }
    static setSeller(request: any) {
        return BaseApi.post(`${baseUrl}Seller`, request);
    }

    static getAllHeadOffice() {
        return BaseApi.get(`${baseUrl}HeadOffice`);
    }
    static getAllBranchOffice(idHeadOffice: string|null) {
        console.log('IdHeadOffice: ',idHeadOffice)
        return BaseApi.get(`${baseUrl}BranchOffice/${idHeadOffice ?? ''}`);        
    }
    static getAllSeller(idBranchOffice: string|null) {
        return BaseApi.get(`${baseUrl}Seller/${idBranchOffice}`);
    }

    static getHeadOfficeActual(UserId: string) {
        return BaseApi.get(`${baseUrl}HeadOfficeActual/${UserId}`);
    }
    static getBranchOffice(UserId: string) {
        return BaseApi.get(`${baseUrl}BranchOffice/${UserId}`);
    }
    static getBranchOfficeActual(UserId: string) {
        return BaseApi.get(`${baseUrl}BranchOfficeActual/${UserId}`);
    }
    static getSeller(UserId: string) {
        return BaseApi.get(`${baseUrl}Seller/${UserId}`);
    }
    
    static deleteHeadOffice(id: string) {
        return BaseApi.delete(`${baseUrl}HeadOffice/${id}`);
    }
    static deleteSeller(id: string) {
        return BaseApi.delete(`${baseUrl}Seller/${id}`);
    }
    
    static deleteBranchOffice(id: string) {
        return BaseApi.delete(`${baseUrl}BranchOffice/${id}`);
    }
    static putActiveUser(id: string) {
        return BaseApi.put(`${baseUrl}ActiveUser/${id}`);
    }

}
export default AuthorizedStoreService;